<script type="text/javascript">
    // const _BASE_ = 'http://192.168.1.117:8086/';
    //const _BASE_ = 'http://localhost:8088/';
    const _BASE_ = 'https://www.quicklive.net.cn/';
    //const _BASE_ = 'https://quicklive.hebhaisi.cn/';
    //const _BASE_ = '/';
    // 定义一些公共的属性和方法
    const AUTH_TMPL_DOWNLOAD = _BASE_ + 'asserts/auth_templet.docx';
    // 登录
    const LOGON_URL = _BASE_ + 'sponsor/doLogon';
    // 上传签名获取链接
    const UPLOADER_TOKEN_URL = _BASE_ + 'ali/aliToken';
    // 获取OSS上传授权的链接
    const OSS_CREDENTIAL_URL = _BASE_ + 'ali/ossCredential';
    // 获取OSS敏感信息上传授权的链接
    const OSS_PRI_CREDENTIAL_URL = _BASE_ + '/ali/ossPriCredential';
    // 加载反馈
    const SPONSOR_TICKLING_LIST_URL = _BASE_ + 'tickling/ticklingList';
    // 发起反馈
    const ADD_TICKLING_URL = _BASE_ + 'tickling/saveTl';
    // 观众反馈
    const FEEDBACK_LIST_URL = _BASE_ + 'uf/userFeedbackList';
    // 观众反馈
    const COMPLAIN_LIST_URL = _BASE_ + 'complain/complainList';
    // 点播锁定
    const LOCK_VOD_URL = _BASE_ + 'vod/lock';
    // 删除点播
    const DELETE_VOD_URL = _BASE_ + 'vod/delete';

    /*手机号是否合法 */
    function phoneValid(phone) {
        return phone && (/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone));
    }

    /* 伪guid*/
    function guid() {
        return (new Date()).getTime() + (((1 + Math.random()) * 0x10000) | 0).toString(16) + (((1 + Math.random()) * 0x10000) | 0).toString(16)
            + (((1 + Math.random()) * 0x10000) | 0).toString(16) + (((1 + Math.random()) * 0x10000) | 0).toString(16);
    }

    // 获得文件扩展名
    function fileExt(filename) {
        return filename.split('.').pop().toLowerCase();
    }

    /**
     * 格式化大小，根据大小范围，切换单位
     * @param size 大小，返回大小和单位的数组
     */
    function formatSize(size){
        let isMinus=false, result = [0, ' B'];
        if (!size){
            size=0;
        }
        if (isNaN(size) && /\D/.test(size)) {
            return result;
        }
        if (size<0){
            isMinus=true;
            size = Math.abs(size);
        }
        function round(num, precision) {
            return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
        }

        let boundary = Math.pow(1024, 4), prefix = (isMinus? '-' : '') , units = ['T', 'G', 'M', 'K', 'B'];
        for(let i=0; i<units.length; i++,boundary/=1024){
            if(size > boundary){
                result[0] = prefix + round(size / boundary, 1);
                result[1] = units[i];
                return result;
            }

        }
        return result;
    }
    function seconds2duration (seconds) {
        let prefix = seconds >= 0 ? "" : "-";
        seconds = Math.abs(seconds);
        var hours = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);
        var time = "";

        if (hours !== 0) {
            time = hours + ":";
        }
        minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
        time += minutes + ":";
        time += (seconds < 10) ? "0" + seconds : String(seconds);
        return prefix+time;
    }
    function addCommas(num){
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    }
    function isEmpty(v){
        return !v || v === '';
    }
    // 确保格式合法
    function assertPath(path){
        if(path.substring(path.length - 1) !== '/'){ path += "/";}
        return path;
    }
    function passwordStrength(pwd) {
        if (pwd.length < 8 || /^[0-9]{1,8}$/.test(pwd)) {
            return 0;
        }
        let strength = 0;
        if (pwd.match(/[a-z]/g)) {
            strength++;
        }
        if (pwd.match(/[A-Z]/g)) {
            strength++;
        }
        if (pwd.match(/[0-9]/g)) {
            strength++;
        }
        if (pwd.match(/[^a-zA-Z0-9]/g)) {
            strength++;
        }
        if (pwd.length < 8 && strength > 1) {
            strength = 1;
        }
        return strength;
    }
    // 暴露出这些属性和方法
    export default {
        _BASE_,
        AUTH_TMPL_DOWNLOAD,
        LOGON_URL,
        UPLOADER_TOKEN_URL,
        OSS_CREDENTIAL_URL,
        OSS_PRI_CREDENTIAL_URL,
        SPONSOR_TICKLING_LIST_URL,
        ADD_TICKLING_URL,
        FEEDBACK_LIST_URL,
        COMPLAIN_LIST_URL,
        LOCK_VOD_URL,
        DELETE_VOD_URL,
        phoneValid,
        guid,
        fileExt,
        formatSize,
        seconds2duration,
        addCommas,
        isEmpty,
        assertPath,
        passwordStrength
    }
</script>